import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AnnouncementBanner from "@/components/base/AnnouncementBanner";
import { getPublicAnnouncements } from "@/lib/webContentApi";
import { AnnouncementItem } from "@/lib/webContentTypes";

export default function AnnouncementsSection() {
  const [active, setActive] = useState<AnnouncementItem[]>([]);

  useEffect(() => {
    getPublicAnnouncements(3)
      .then((items) => setActive(items.filter((item) => item.active).slice(0, 3)))
      .catch(() => setActive([]));
  }, []);

  if (active.length === 0) return null;

  return (
    <section className="bg-slate-50 py-14 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <span className="w-2.5 h-2.5 rounded-full bg-orange-500 animate-pulse flex-shrink-0"></span>
            <span className="text-xs font-bold uppercase tracking-widest text-slate-500">
              Avisos importantes
            </span>
          </div>
          <Link
            to="/comunicados"
            className="text-sm text-sky-600 hover:text-sky-800 font-semibold cursor-pointer whitespace-nowrap"
          >
            Ver todos <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="flex flex-col gap-4">
          {active.map((a) => (
            <AnnouncementBanner key={a.id} announcement={a} />
          ))}
        </div>
      </div>
    </section>
  );
}
